import React from 'react';
import UtilityQuickCapture from './UtilityQuickCapture';
import UtilityScratchpad from './UtilityScratchpad';
import UtilityContextView from './UtilityContextView';

const UtilityPanel = () => {
  return (
    <aside className="utility-panel" data-testid="utility-panel">
      <UtilityQuickCapture />
      <UtilityScratchpad />
      <UtilityContextView />
    </aside>
  );
};

export default UtilityPanel;
